import { Dropdown, Tooltip, type MenuProps } from "antd";
import { MenuSvgIcon } from "./MenuSvgIcon";

export interface RightMenuProps {
    onCloseOthers: () => void;
    onCloseAll: () => void;
}

/** 标签栏右侧历史页签菜单。 */
export function RightMenu({ onCloseOthers, onCloseAll }: RightMenuProps) {
    const items: MenuProps["items"] = [
        { key: "close-others", label: "关闭其它", onClick: onCloseOthers },
        { key: "close-all", label: "关闭所有", onClick: onCloseAll }
    ];

    return (
        <Dropdown trigger={["click"]} menu={{ items }}>
            <span className="tabs-control">
                <Tooltip title="关闭历史页签" placement="bottom">
                    <button type="button" className="right-menu-icon" aria-label="关闭历史页签">
                        <MenuSvgIcon />
                    </button>
                </Tooltip>
            </span>
        </Dropdown>
    );
}

export default RightMenu;
